<template>
  <div v-if="status && statusLabel">
    <StatusIndicator :color="indicatorColour">{{ statusLabel }}</StatusIndicator>
  </div>
</template>

<script>
import { decorators } from '@sohohouse/platform-resources'
import { StatusIndicator } from '@sohohouse/design-system'
import { EVENT_STATUSES, EVENT_BOOKING_STATUSES } from './constants'

const { DateTime } = decorators.shared

export default {
  components: {
    StatusIndicator
  },
  props: {
    status: {
      type: String,
      required: true,
      validator: value =>
        Object.keys(EVENT_STATUSES).includes(value) ||
      Object.keys(EVENT_BOOKING_STATUSES).includes(value)
    },
    date: {
      type: [Object, String],
      required: false
    },
    timezone: {
      type: String,
      required: false
    },
    guests: {
      type: Number,
      required: false,
      default: 0
    },
    ticketless: {
      type: Boolean,
      required: false
    },
    isActive: {
      type: Boolean,
      default: false
    },
    digital: {
      type: Object
    }
  },
  computed: {
    formattedDate () {
      return this.$d(new DateTime(this.date).setTimezone(this.timezone).withOffset.epoch, 'abrDateTime')
    },
    indicatorColour () {
      if (this.isActive) {
        return false
      }

      if (Object.keys(EVENT_BOOKING_STATUSES).includes(this.status)) {
        return EVENT_BOOKING_STATUSES[this.status].colour
      }
      return EVENT_STATUSES[this.status].colour
    },
    statusLabel () {
      if (Object.keys(EVENT_BOOKING_STATUSES).includes(this.status)) {
        if (this.status === EVENT_BOOKING_STATUSES.CONFIRMED.code && this.ticketless) {
          return this.$t('EXPLORE_EVENTS_EVENT_TICKETLESS_CARD_LABEL')
        }

        if (this.status === EVENT_BOOKING_STATUSES.CONFIRMED.code && this.guests > 0) {
          return this.$t('EXPLORE_EVENTS_EVENT_GUESTS_CARD_LABEL', { number: this.guests })
        }

        return this.$t(EVENT_BOOKING_STATUSES[this.status].label)
      }

      if (this.status === EVENT_STATUSES.BOOKING_OPENS_DATE.code) {
        return this.$t(EVENT_STATUSES.BOOKING_OPENS_DATE.label, { date: this.formattedDate })
      }

      if (EVENT_STATUSES.HOUSE_MEMBER_ONLY.code === this.status && this.isActive) {
        return this.$t('EXPLORE_EVENTS_EVENT_ACTIVE_MEMBERS_LABEL')
      }

      if (this.status === EVENT_STATUSES.HAPPENING_NOW.code && this.digital) {
        return this.$t('DIGITAL_EVENT_HAPPENING_NOW')
      }

      return this.$t(EVENT_STATUSES[this.status].label)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
